import { render } from "./alert_message.vue?vue&type=template&id=7288ff4a"
import script from "./alert_message.vue?vue&type=script&lang=js"
export * from "./alert_message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__